import React, { useState } from 'react'

// queries
import { useMutation } from '@apollo/client'
import { GET_TOKEN_MUTATION } from '../../../graphql/authentication/authentication.mutation'

// collections
import LoginForm from './Login.form'

// mui
import { Alert } from '@mui/material'

export default function LoginFormController({ onSuccess }) {
    const [errors, setErrors] = useState(null)
    const [loginUser, ] = useMutation(GET_TOKEN_MUTATION)

    const handleSubmit = (formData) => {
        loginUser({ variables: {...formData}})
        .catch(e => {
            if(e) { setErrors(e)}
        }).then(result => {
            if(result.data && result.data.tokenAuth) {
                const { tokenAuth } = result.data;
                if(tokenAuth.success) {
                    const { token, refreshToken } = tokenAuth;
                    onSuccess(token, refreshToken)
                } else {
                    setErrors(tokenAuth.errors.nonFieldErrors[0])
                }
            }
        })
    }

    return (<div>
        <LoginForm 
            handleSubmit={handleSubmit}
        />
        { errors && <Alert severity='error' sx={{ marginTop: 2 }}>{errors.message}</Alert>}
        </div>)
}